import Switcher from './switcher'

export default Switcher